import Event from '../../core/Event';

export default class EstimationsImportRequested extends Event {
    public static type = 'EstimationsImportRequested';

    constructor(public readonly rows: string[][]) {
        super(EstimationsImportRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/estimations/events/EstimationsImportRequested.ts